import { RioApiGet, RioApiPost } from "rio.react.all";
import { AccountStatementEmailSendRequestApiModel } from "../apiModels/AccountStatementEmailSendRequestApiModel";
import { AccountStatementTemplateApiModel } from "../apiModels/AccountStatementTemplateApiModel";
import { NavisionDocumentApiModel } from "../apiModels/NavisionDocumentApiModel";


export class AccountStatementApi {
    static getCurrentTemplate() {
        return RioApiGet.asPromise<AccountStatementTemplateApiModel>("/api/AccountStatements/GetCurrentTemplate/");
    }

    static saveTemplate(template: AccountStatementTemplateApiModel) {
        return RioApiPost.asPromise<AccountStatementTemplateApiModel>("/api/AccountStatements/TemplateAddUpdate", template);
    }

    static queueSend(request: AccountStatementEmailSendRequestApiModel) {
        return RioApiPost.asPromise<number>("/api/AccountStatements/QueueSend", request);
    }

    static getPendingStatements() {
        return RioApiGet.asPromise<Array<NavisionDocumentApiModel>>("/api/AccountStatements/GetPendingStatements");
    }

    static deleteStatement(statementID: number) {
        return RioApiPost.asPromise<void>("/api/AccountStatements/DeleteStatement", statementID);
    }

    static bulkDeleteStatements(statements: Array<NavisionDocumentApiModel>) {
        return RioApiPost.asPromise<void>("/api/AccountStatements/BulkDeleteStatements", statements);
    }

    static getShowAttachReservesListCheckbox() {
        return RioApiGet.asPromise<boolean>("/api/AccountStatements/GetShowAttachReservesListCheckbox/");
    }
}